/*!
    * Theme scripts 
    * @company Reactive Development LLC
    * @author Jeremy Selph <jselph@reactivedevelopment.net>
    * @link http://www.reactivedevelopment.net
    * @version 0.2 [ ver 0.1 is template file ]
*/ /*
        * html 5 boilerplate javascript for testing in chrome and firebug console
        * make sure to comment out when u go live
        * Avoid `console` errors in browsers that lack a console.
        * @since 0.1
    */
    (function() {
        
        var method;
        var noop = function () {};
        var methods = [
            'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
            'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
            'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
            'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
        ];
        
        var length = methods.length;
        var console = (window.console = window.console || {});

        while (length--) {
            
            method = methods[length];

            /**             
                * Only stub undefined methods.
                * @since 0.1
            */
            if ( !console[method] ) { console[method] = noop; }

        }

    }());

    /**             
        * jquery onload
        * @author Jeremy Selph <jselph@reactivedevelopment.net>
        * @uses jquery.min.js
        * @since 0.1
    */
    jQuery( document ).ready(function() {

        /**
            * jquery cycle  height fix
            * @author Jeremy Selph <jselph@reactivedevelopment.net>
            * @uses jquery.min.js, jquery.cycle2.min.js
            * @since 0.1
        */ 
        jQuery( ".cycle-slideshow" )
            .on( "cycle-before", function(
                event, optionHash, outgoingSlideEl, incomingSlideEl, forwardFlag ) {
            
            jQuery( this ).css( "height", jQuery( incomingSlideEl ).height() );

        });

        /**
            * jquery cycle next and prev [ main slider ]
            * @author Jeremy Selph <jselph@reactivedevelopment.net>
            * @uses jquery.min.js, jquery.cycle2.min.js
            * @since 0.1
        */ 
        jQuery( ".slideArrowBtn.prev" ).click(function() { jQuery( "#project_slider" ).cycle( "prev" ); return false; });
        jQuery( ".slideArrowBtn.next" ).click(function() { jQuery( "#project_slider" ).cycle( "next" ); return false; });

    });